/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface InfoProps extends React.SVGAttributes<SVGElement> {
size?: string;
}
const Info: React.SFC<InfoProps> = ({size, ...props}) => (
  <svg viewBox="0 0 100 100" fill="currentColor" width={ size || "1em" } height={ size || "1em" } {...props}>
    <defs/>
    <path d="M54.39 66.94h2.67A3.06 3.06 0 0160.12 70h0a3.06 3.06 0 01-3.06 3.06H43.73A3.06 3.06 0 0140.67 70h0a3.06 3.06 0 013.06-3.06h2.43a.76.76 0 00.75-.75V48.6a.76.76 0 00-.75-.75H44.3a3.06 3.06 0 01-3.06-3.06h0a3.06 3.06 0 013.06-3.06h6.28a3.06 3.06 0 013.06 3.06v21.4A.75.75 0 0054.39 66.94zM50 25.73a4.42 4.42 0 013.34 1.46 4.94 4.94 0 011.36 3.47 4.65 4.65 0 01-4.75 4.75 4.56 4.56 0 01-3.38-1.36 4.61 4.61 0 01-1.37-3.39 4.82 4.82 0 011.41-3.47A4.56 4.56 0 0150 25.73z"
      className="cls-1" />
    <path d="M50,99.56A49.56,49.56,0,1,1,99.56,50,49.61,49.61,0,0,1,50,99.56ZM50,6.05A44,44,0,1,0,94,50,44,44,0,0,0,50,6.05Z" className="cls-1" />
  </svg>
);
Info.displayName = 'Info';
export default Info;
/* tslint:enable */
/* eslint-enable */
